module.exports = __webpack_public_path__ + "static/media/11NEPAD12.4d231330.jpg";